import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { usePreviewRemarks } from '../hooks';

interface RemarksSectionProps {
  showTitle?: boolean;
}

const RemarksSection: React.FC<RemarksSectionProps> = ({
  showTitle = false,
}) => {
  const remarks = usePreviewRemarks();

  if (!remarks) return null;

  return (
    <Box sx={{ mb: showTitle ? 3 : 0 }}>
      {showTitle && (
        <>
          <Divider sx={{ mb: 1 }} />
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              letterSpacing: '0.05em',
              color: 'text.primary',
            }}
          >
            Public Remarks
          </Typography>
        </>
      )}
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ whiteSpace: 'pre-wrap', py: 1 }}
      >
        {remarks}
      </Typography>
    </Box>
  );
};

export default React.memo(RemarksSection);
